import React from "react";

/** Purple→pink gradient background with 4 white equalizer bars */
export const PerformanceZoneIcon: React.FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="perf-zone-grad"
        x1="0"
        y1="0"
        x2="40"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7C3AED" />
        <stop offset="1" stopColor="#C026D3" />
      </linearGradient>
    </defs>
    <rect width="40" height="40" rx="8" fill="url(#perf-zone-grad)" />
    {/* 4 equalizer bars */}
    <rect x="7"  y="25" width="5" height="8"  rx="1.5" fill="white" />
    <rect x="14" y="19" width="5" height="14" rx="1.5" fill="white" />
    <rect x="21" y="13" width="5" height="20" rx="1.5" fill="white" />
    <rect x="28" y="21" width="5" height="12" rx="1.5" fill="white" />
  </svg>
);
